import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button,
} from '@lockerpm/design';

import {
  ArrowLeftOutlined
} from "@ant-design/icons";

import commonServices from "../../../../services/common";

const SetUpPwlTitle = (props) => {
  const { t } = useTranslation();
  const {
    step,
    callingAPI,
    setStep,
    setIsPair,
  } = props;

  const isTouch = useSelector(state => state.service.isTouch)
  const isFingerprint = useSelector(state => state.service.isFingerprint)

  return (
    <div className="mb-6 text-center">
      <div className="w-full flex items-center justify-center">
        {
          step > 1 && !(callingAPI || isTouch || isFingerprint) && <Button
            className="mr-2"
            type={'text'}
            icon={<ArrowLeftOutlined />}
            onClick={async () => {
              await commonServices.reset_service();
              setStep(step - 1);
              setIsPair(false);
            }}
          />
        }
        <p className="text-2xl font-semibold">
          { t('auth_pages.authenticate.setup_pwl') }
        </p>
      </div>
      <p className="mt-2">{t('auth_pages.authenticate.setup_pwl_description')}</p>
    </div>
  );
}

export default SetUpPwlTitle;